import { CONSTANTS } from "../../../constants/Constant";
import { DealManager } from "../../../managers/DealManager";
import { COLUMN_CODE, TABLES } from "../../../managers/TableManger";

class JobPipelineService {
    static pipelineData;
    static stageData;
    static selectedPielineId = null;
    static getPipelineData(dataSource) {
        let pipelineDataList = [];
        if(dataSource && dataSource.length > 0) {
            dataSource.forEach(data => {
                let fields = {
                    id: data._id,
                    [COLUMN_CODE.JOB_PIPELINE.NAME]: data.cells[DealManager.getColumnId(COLUMN_CODE.JOB_PIPELINE.NAME, TABLES.JOB_PIPELINE)] === CONSTANTS.DEFAULT_JOB_PIPELINE ? CONSTANTS.DEFAULT_PIPELINE : data.cells[DealManager.getColumnId(COLUMN_CODE.JOB_PIPELINE.NAME, TABLES.JOB_PIPELINE)],
                    [COLUMN_CODE.JOB_PIPELINE.STAGE_ID_S]: data.cells[DealManager.getColumnId(COLUMN_CODE.JOB_PIPELINE.STAGE_ID_S, TABLES.JOB_PIPELINE)],
                    color: "data-grid-badge-color-4",
                    type: CONSTANTS.PIPELINE,
                }
                pipelineDataList.push(fields)
            });
        }
        return pipelineDataList
    }
    static getStageData(dataSource) {
        let stageDataList = [];
        if (dataSource && dataSource.length > 0) {
            dataSource.forEach(data => {
                let fields = {
                    id: data._id,
                    [COLUMN_CODE.JOB_STAGE.NAME]: data.cells[DealManager.getColumnId(COLUMN_CODE.JOB_STAGE.NAME, TABLES.JOB_STAGE)],
                    type: CONSTANTS.STAGE,
                    color: "data-grid-badge-color-7",
                    // [COLUMN_CODE.JOB_PIPELINE.STAGE_ID_S]: data.cells[DealManager.getColumnId(COLUMN_CODE.JOB_PIPELINE.STAGE_ID_S, TABLES.JOB_PIPELINE)]
                }
                stageDataList.push(fields)
            });
        }
        return stageDataList;
    }

    static getSegmentData(dataSource) {
        let stageDataList = [];
        if (dataSource && dataSource.length > 0) {
            dataSource.forEach(data => {
                let fields = {
                    id: data._id,
                    [COLUMN_CODE.JOB_STAGE.NAME]: data.cells[DealManager.getColumnId(COLUMN_CODE.JOB_STAGE.NAME, TABLES.JOB_STAGE)],
                    type: CONSTANTS.STAGE,
                    color: "data-grid-badge-color-7",
                    // [COLUMN_CODE.JOB_PIPELINE.STAGE_ID_S]: data.cells[DealManager.getColumnId(COLUMN_CODE.JOB_PIPELINE.STAGE_ID_S, TABLES.JOB_PIPELINE)]
                }
                stageDataList.push(fields)
            });
        }
        return stageDataList;
    }
    static getStageDataWithPipelineName(dataSource, pipelines) {
        let stageDataList = [];
        if (dataSource && dataSource.length > 0) {
            dataSource.forEach(data => {
                let pipelineName = "";
                const pipeLineData = []
                pipelines.filter((x) => {
                    const stageIds = x[COLUMN_CODE.JOB_PIPELINE.STAGE_ID_S];
                    if(stageIds && stageIds.some((y) => y == data._id)) {
                        pipeLineData.push(x);
                    }
                }
                );
                if (pipeLineData && pipeLineData.length > 0) {
                    pipelineName = pipeLineData[0].name;
                    pipelineName = ` (${pipelineName})`
                }
                let fields = {
                    id: data._id,
                    [COLUMN_CODE.JOB_STAGE.NAME]: data.cells[DealManager.getColumnId(COLUMN_CODE.JOB_STAGE.NAME, TABLES.JOB_STAGE)] + pipelineName,
                    type: CONSTANTS.STAGE,
                    color: "data-grid-badge-color-7",
                    // [COLUMN_CODE.JOB_PIPELINE.STAGE_ID_S]: data.cells[DealManager.getColumnId(COLUMN_CODE.JOB_PIPELINE.STAGE_ID_S, TABLES.JOB_PIPELINE)]
                }
                stageDataList.push(fields)
            });
        }
        return stageDataList;
    }
}

export default JobPipelineService;